import { render, staticRenderFns } from "./IndustryCases.vue?vue&type=template&id=4747668d&scoped=true"
import script from "./IndustryCases.vue?vue&type=script&lang=js"
export * from "./IndustryCases.vue?vue&type=script&lang=js"
import style0 from "./IndustryCases.vue?vue&type=style&index=0&id=4747668d&prod&lang=scss&scoped=true"
import style1 from "./IndustryCases.vue?vue&type=style&index=1&id=4747668d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747668d",
  null
  
)

export default component.exports